/**
 * Centralized, typed access to Vite environment configuration.
 * All values are read once at module load.
 */

function trimTrailingSlash(value: string): string {
  return value.replace(/\/$/, '');
}

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID ?? '';
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID ?? '';
const redirectUri = import.meta.env.VITE_ENTRA_REDIRECT_URI ?? window.location.origin;
const apiScope = import.meta.env.VITE_API_SCOPE ?? '';

export const env = {
  /** Empty in dev (Vite proxy handles `/api`); the API origin in prod. */
  apiBaseUrl: trimTrailingSlash(import.meta.env.VITE_API_BASE_URL ?? ''),
  entra: {
    tenantId,
    clientId,
    redirectUri,
    apiScope,
    authority: tenantId ? `https://login.microsoftonline.com/${tenantId}` : '',
  },
} as const;

/** True only when the minimum Entra config required to initialize MSAL is present. */
export const isAuthConfigured = Boolean(env.entra.tenantId && env.entra.clientId);
